import styled, { useTheme } from 'styled-components';
import { Footer } from 'mlb-react-header';
import { getMlbHeaderTheme } from '@mlb/play-ui';
import { Skeleton } from '@gif/shared-ui';
import { getLang } from '@gif/shared-global';

import { useGetFooterDataQuery } from '../../api';
import { FooterLegal } from '..';

const StyledMlbFooter = styled.section`
  margin-top: auto;
  display: flex;
  flex-direction: column;
`;

const LegalSkeleton = styled(Skeleton)`
  margin: 1rem auto;
`;
const lang = getLang();

export interface MlbFooterProps {
  hideLegalText?: boolean;
}

export function MlbFooter({ hideLegalText = false }: MlbFooterProps) {
  const theme = useTheme() as any;
  const { data, isLoading } = useGetFooterDataQuery({ lang });

  if (isLoading) {
    return (
      <>
        {!hideLegalText && <LegalSkeleton width="15rem" />}
        <Skeleton height="12rem" />
      </>
    );
  }

  return (
    <StyledMlbFooter>
      {!hideLegalText && <FooterLegal />}
      <Footer
        locale={lang}
        footerData={data}
        contentfulProps={{ palette: getMlbHeaderTheme(theme.id) }}
      />
    </StyledMlbFooter>
  );
}

export default MlbFooter;
